import React, {Component} from 'react';
import {connect} from "react-redux";
import { withTranslation } from 'react-i18next';
import Icon from "../../../../../../components/icon";
import Button from "../../../../../../components/button";
import {getSharingDetailsPopup} from "../../../../../../../actions/sharingDetailsActions";

class LabelRenameLimitForInvitedPopup extends Component {

    constructor(props){
        super(props);

        this.closeHandler = this.closeHandler.bind(this);
    }

    closeHandler(){
        this.props.getSharingDetailsPopup([]);
    }

    render() {
        return (
            <div className="p-4">
                <h2><Icon name="times" className="text-danger"/> <span className="text-danger">{this.props.t("errorText")}</span></h2>
                <p>{this.props.t('msgBarErrorRenameText3')}</p>
                <div className="text-right">
                    <Button className="btn-primary" onClick={this.closeHandler}>{this.props.t("okText")}</Button>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    getSharingDetailsPopup: (array) => {
        dispatch(getSharingDetailsPopup(array))
    },
});

export default connect(null, mapDispatchToProps)(withTranslation()(LabelRenameLimitForInvitedPopup));